import { EventResult } from '../../utils/types'
import { configs } from '../../configs'
import { HttpStatusCode } from 'axios/index'
import ReigniteSseHub from './ReigniteSseHub'

const ReigniteEventResultsHub = ({
  onMessage,
  updateIsLoading,
  params
}: {
  onMessage: (parsed: { data: EventResult[], status: HttpStatusCode }) => void
  updateIsLoading: (value: boolean) => void
  params: {
    asOf: number
    ctliveEventId: number
    ctliveRaceId?: number
    athlinksEventId: number
    eventCourseId?: number
    divisionId?: number
    from: number
    limit: number
  }
}) => {
  const {
    asOf,
    ctliveEventId,
    ctliveRaceId,
    athlinksEventId,
    eventCourseId,
    divisionId,
    from,
    limit
  } = params

  return <ReigniteSseHub
    asOf={asOf}
    onMessage={onMessage}
    params={{
      path: `azp/ctlive/event/${ctliveEventId}${ctliveRaceId ? `/race/${ctliveRaceId}` : ''}${divisionId && ctliveRaceId ? `/bracket/${divisionId}` : ''}`,
      url: `${configs.resultsApiUrl}/event/${athlinksEventId}?eventCourseId=${eventCourseId || ''}&divisionId=${divisionId || ''}&from=${from}&limit=${limit}`,
    }}
    updateIsLoading={updateIsLoading}
  />
}

export default ReigniteEventResultsHub
